/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: BI Dashboard
 *| (C) Copyright IBM Corp. 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

define([
	'../../../lib/@waca/upgrades/UpgradeBase'
], (UpgradeBase) => {

	class DrillthroughDefinitionScopeUpgrade extends UpgradeBase {

		constructor() {
			super();
			this.VERSION = 1404;
		}

		/**
		 * Perform upgrades for drillthrough definitions. The old property needs
		 * to be deleted and mapped to the appropriate scope since we now support 3
		 * rather than 2.
		 * @param {object} spec - spec to perform upgrade on
		 *
		 * @return {Promise} Promise to be resolved when upgrade performed
		 */
		up(spec) {
			if (spec && spec.drillThrough && spec.drillThrough.length) {
				spec.drillThrough.forEach((definition) => {
					definition.scope = definition.reusable ? 'connection' : 'visualization';
					delete definition.reusable;
				});
			}
			return Promise.resolve(spec);
		}
	}

	return new DrillthroughDefinitionScopeUpgrade();

});
